<template>
  <div class="submit-tool-page bg-neutral-100 min-h-screen">
    <section class="py-16">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div
          class="max-w-3xl mx-auto bg-white rounded-xl p-6 md:p-8 border border-neutral-200 shadow-sm"
        >
          <div class="text-center mb-8">
            <h2 class="text-2xl md:text-3xl font-bold mb-4">发布你的AI工具</h2>
            <p class="text-neutral-500">
              分享你创建的AI工具，获得更多曝光和积分奖励
            </p>
          </div>

          <form @submit.prevent="handleSubmit" class="space-y-5">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <label
                  for="tool-name"
                  class="block text-sm font-medium text-neutral-700 mb-1"
                  >工具名称</label
                >
                <input
                  type="text"
                  id="tool-name"
                  v-model="form.title"
                  required
                  class="w-full px-4 py-2 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary focus:border-primary apple-transition"
                  placeholder="输入你的工具名称"
                />
              </div>

              <div>
                <label
                  for="tool-category"
                  class="block text-sm font-medium text-neutral-700 mb-1"
                  >工具分类</label
                >
                <div class="relative w-full">
                  <select
                    id="tool-category"
                    v-model="form.categoryid"
                    required
                    class="w-full px-4 py-2 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary focus:border-primary apple-transition appearance-none bg-white"
                  >
                    <option
                      v-for="item in categories"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.title }}
                    </option>
                  </select>
                  <!-- 自定义下拉箭头（解决 Safari 默认箭头样式问题） -->
                  <div
                    class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                  >
                    <svg
                      width="12"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L6 6L11 1"
                        stroke="#666"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <label
                for="tool-description"
                class="block text-sm font-medium text-neutral-700 mb-1"
                >所属学科</label
              >

              <div class="flex flex-wrap gap-3">
                <div
                  v-for="fmt in subList"
                  :key="fmt.id"
                  @click="setSub(fmt.id)"
                  class="px-4 py-2.5 rounded-2xl text-sm font-bold transition-all duration-200 border"
                  :class="
                    form.subid == fmt.id
                      ? 'bg-stone-800 border-stone-800 text-white shadow-lg shadow-stone-800/30'
                      : 'bg-white border-stone-200 text-stone-600 hover:bg-stone-50'
                  "
                >
                  {{ fmt.title }}
                </div>
              </div>
            </div>

            <div>
              <label
                for="tool-description"
                class="block text-sm font-medium text-neutral-700 mb-1"
                >工具描述</label
              >
              <textarea
                id="tool-description"
                v-model="form.description"
                required
                rows="4"
                class="w-full px-4 py-2 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary focus:border-primary apple-transition"
                placeholder="详细描述你的工具功能、使用方法和特点"
              ></textarea>
            </div>

            <!-- <div>
              <label
                for="tool-url"
                class="block text-sm font-medium text-neutral-700 mb-1"
                >工具访问链接</label
              >
              <input
                type="url"
                id="tool-url"
                v-model="form.link"
                required
                class="w-full px-4 py-2 rounded-md border border-neutral-300 focus:ring-2 focus:ring-primary focus:border-primary apple-transition"
                placeholder="https://your-tool-url.com"
              />
            </div> -->

            <div>
              <label class="block text-sm font-medium text-neutral-700 mb-1"
                >工具封面图</label
              >
              <div class="flex items-center justify-center w-full">
                <!-- 图片预览区域 -->
                <div v-if="form.coverPreview" class="relative w-full h-32 mb-4">
                  <img
                    :src="form.coverPreview"
                    alt="封面预览"
                    class="w-full h-full object-cover rounded-md border border-neutral-200"
                  />
                  <button
                    type="button"
                    @click="clearCover"
                    class="absolute top-2 right-2 bg-black/50 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-black/70 transition-colors"
                  >
                    ×
                  </button>
                </div>

                <!-- 上传区域 -->
                <label
                  v-else
                  for="file-upload"
                  class="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-neutral-300 rounded-md cursor-pointer bg-neutral-50 hover:bg-neutral-100 apple-transition"
                >
                  <div
                    class="flex flex-col items-center justify-center pt-5 pb-6"
                  >
                    <i class="fa fa-cloud-upload text-neutral-400 mb-2"></i>
                    <p class="mb-2 text-sm text-neutral-500">
                      <span class="font-medium">点击上传</span> 或拖放文件
                    </p>
                    <p class="text-xs text-neutral-500">
                      支持 PNG, JPG 或 GIF (最大 10MB)
                    </p>
                  </div>
                  <input
                    id="file-upload"
                    type="file"
                    class="hidden"
                    accept="image/*"
                    @change="handleFileUpload"
                  />
                </label>
              </div>
              <!-- 上传状态提示 -->
              <div v-if="uploading" class="mt-2 text-sm text-primary">
                图片上传中...
              </div>
              <div v-if="uploadError" class="mt-2 text-sm text-red-500">
                {{ uploadError }}
              </div>
            </div>

            <!-- 新增：ZIP附件上传区域 -->
            <div>
              <label class="block text-sm font-medium text-neutral-700 mb-1"
                >工具附件 (仅支持ZIP压缩包)</label
              >
              <div class="flex items-center justify-center w-full">
                <!-- 附件文件预览区域 -->
                <div
                  v-if="form.zipFileName"
                  class="relative w-full mb-4 bg-neutral-50 rounded-md border border-neutral-200 p-3 flex items-center justify-between"
                >
                  <div class="flex items-center">
                    <i class="fa fa-file-archive-o text-primary mr-2"></i>
                    <span class="text-sm text-neutral-700 truncate">{{
                      form.zipFileName
                    }}</span>
                    <span class="ml-2 text-xs text-neutral-500"
                      >({{ formatFileSize(form.zipFileSize) }})</span
                    >
                  </div>
                  <button
                    type="button"
                    @click="clearZipFile"
                    class="text-neutral-500 hover:text-red-500 transition-colors"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>

                <!-- 附件上传区域 -->
                <label
                  v-else
                  for="zip-file-upload"
                  class="flex flex-col items-center justify-center w-full h-24 border-2 border-dashed border-neutral-300 rounded-md cursor-pointer bg-neutral-50 hover:bg-neutral-100 apple-transition"
                >
                  <div
                    class="flex flex-col items-center justify-center pt-5 pb-6"
                  >
                    <i class="fa fa-file-zip-o text-neutral-400 mb-2"></i>
                    <p class="mb-2 text-sm text-neutral-500">
                      <span class="font-medium">点击上传</span> 或拖放ZIP文件
                    </p>
                    <p class="text-xs text-neutral-500">
                      仅支持 ZIP 格式 (最大 50MB)
                    </p>
                  </div>
                  <input
                    id="zip-file-upload"
                    type="file"
                    class="hidden"
                    accept=".zip"
                    @change="handleZipFileUpload"
                  />
                </label>
              </div>
              <!-- 附件上传状态提示 -->
              <div v-if="zipUploading" class="mt-2 text-sm text-primary">
                附件上传中...
              </div>
              <div v-if="zipUploadError" class="mt-2 text-sm text-red-500">
                {{ zipUploadError }}
              </div>
            </div>

            <div class="pt-2">
              <button
                type="submit"
                :disabled="uploading || zipUploading || !form.title"
                class="w-full px-6 py-3 rounded-md bg-primary text-white font-medium hover:bg-primary/90 apple-transition shadow-sm disabled:bg-neutral-300 disabled:cursor-not-allowed"
              >
                发布工具
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SubmitToolPage",
  data() {
    return {
      categories: [],
      subList: [],
      form: {
        title: "",
        subid: "",
        categoryid: "",
        description: "",
        link: "",
        cover: "", // 存储服务器返回的图片URL
        coverPreview: "", // 存储本地预览图片的base64
        imageFile: null, // 存储选中的封面文件对象

        // 新增：ZIP附件相关字段
        zipFile: null, // 存储选中的ZIP文件对象
        zipFileName: "", // 存储ZIP文件名
        zipFileSize: 0, // 存储ZIP文件大小(字节)
        zipUrl: "", // 存储服务器返回的ZIP文件URL
      },
      uploading: false, // 封面上传状态
      uploadError: "", // 封面上传错误信息

      // 新增：ZIP上传状态
      zipUploading: false, // ZIP上传状态
      zipUploadError: "", // ZIP上传错误信息
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    // 获取分类列表
    async getCategory() {
      try {
        const res = await this.$axios({
          url: "category/list",
        });
        this.categories = res.data;
        // 确保分类有数据时才设置默认值
        if (this.categories.length > 0) {
          this.form.categoryid = this.categories[0].id;
        }

        const sub = await this.$axios({
          url: "subinfo/list",
        });
        this.subList = sub.data;
        if (this.subList.length > 0) {
          this.form.subid = this.subList[this.subList.length - 1].id;
        }
      } catch (error) {
        console.error("获取分类失败:", error);
        alert("获取分类列表失败，请稍后重试");
      }
    },
    setSub(id) {
      var form = Object.assign({},this.form);
      form.subid = id;
      this.form = Object.assign({},form);
    },

    // 处理封面文件上传选择
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型和大小
      const isImage = file.type.startsWith("image/");
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isImage) {
        this.uploadError = "请上传图片格式的文件（PNG/JPG/GIF）";
        return;
      }

      if (!isLt10M) {
        this.uploadError = "图片大小不能超过10MB";
        return;
      }

      // 清除之前的错误提示
      this.uploadError = "";
      // 保存文件对象
      this.form.imageFile = file;
      // 创建预览图片的URL
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.coverPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    // 清除封面图片
    clearCover() {
      this.form.coverPreview = "";
      this.form.imageFile = null;
      this.form.cover = "";
      this.uploadError = "";
      // 重置文件输入框
      document.getElementById("file-upload").value = "";
    },

    // 新增：处理ZIP文件上传选择
    handleZipFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型（确保是zip文件）
      const isZip =
        file.name.endsWith(".zip") ||
        file.type === "application/zip" ||
        file.type === "application/x-zip-compressed";
      // 验证文件大小（最大50MB）
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isZip) {
        this.zipUploadError = "仅支持上传ZIP格式的压缩文件";
        return;
      }

      if (!isLt50M) {
        this.zipUploadError = "ZIP文件大小不能超过50MB";
        return;
      }

      // 清除之前的错误提示
      this.zipUploadError = "";
      // 保存文件信息
      this.form.zipFile = file;
      this.form.zipFileName = file.name;
      this.form.zipFileSize = file.size;

      // 重置文件输入框值（避免重复选择同一文件不触发change事件）
      // document.getElementById("zip-file-upload").value = "";
    },

    // 新增：清除ZIP文件
    clearZipFile() {
      this.form.zipFile = null;
      this.form.zipFileName = "";
      this.form.zipFileSize = 0;
      this.form.zipUrl = "";
      this.zipUploadError = "";
    },

    // 新增：格式化文件大小显示
    formatFileSize(bytes) {
      if (bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    // 上传图片到服务器
    async uploadImage() {
      if (!this.form.imageFile) return true;

      this.uploading = true;
      this.uploadError = "";

      try {
        // 创建FormData对象用于文件上传
        const formData = new FormData();
        formData.append("file", this.form.imageFile);
        formData.append("UploadType", "Files");
        formData.append(
          "businessType",
          "cover/" + new Date().format("yyyy/MM/dd")
        );

        // 上传图片到服务器（请替换为你的实际上传接口）
        const res = await this.$axios({
          url: "upload", // 图片上传接口
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置的请求头
          },
        });

        // 假设服务器返回 { code: 200, data: { url: "https://xxx.com/xxx.jpg" } }
        if (res.code === 200) {
          console.log(JSON.stringify(res));
          this.form.cover = res.data.uploads.files[0].o.fullPath; // 保存服务器返回的图片URL
          return true;
        } else {
          this.uploadError = res.message || "图片上传失败";
          return false;
        }
      } catch (error) {
        console.error("图片上传失败:", error);
        this.uploadError = "图片上传失败，请检查网络或稍后重试";
        return false;
      } finally {
        this.uploading = false;
      }
    },

    // 新增：上传ZIP文件到服务器
    async uploadZipFile() {
      if (!this.form.zipFile) return true;

      this.zipUploading = true;
      this.zipUploadError = "";

      try {
        // 创建FormData对象用于文件上传
        const formData = new FormData();
        formData.append("file", this.form.zipFile);
        formData.append("UploadType", "Files");
        formData.append(
          "businessType",
          "tool/" + new Date().format("yyyy/MM/dd")
        );

        // 上传ZIP文件到服务器（请替换为你的实际上传接口）
        const res = await this.$axios({
          url: "upload", // ZIP文件上传接口（可复用图片上传接口）
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置的请求头
          },
        });

        // 假设服务器返回格式和图片上传一致
        if (res.code === 200) {
          this.form.fileId = res.data.uploads.id; // 保存服务器返回的ZIP文件URL
          return true;
        } else {
          this.zipUploadError = res.message || "附件上传失败";
          return false;
        }
      } catch (error) {
        console.error("ZIP文件上传失败:", error);
        this.zipUploadError = "附件上传失败，请检查网络或稍后重试";
        return false;
      } finally {
        this.zipUploading = false;
      }
    },

    // 提交表单
    async handleSubmit() {
      // 1. 先验证必要字段
      if (!this.form.title || !this.form.categoryid) {
        alert("请填写完整的表单信息");
        return;
      }

     

      // 2. 如果有图片文件但还没上传，先上传图片
      let uploadSuccess = true;
      if (this.form.imageFile) {
        uploadSuccess = await this.uploadImage();
        if (!uploadSuccess) {
          return; // 上传失败则终止提交
        }
      }

      // 3. 新增：如果有ZIP文件但还没上传，先上传ZIP文件
      if (this.form.zipFile) {
        uploadSuccess = await this.uploadZipFile();
        if (!uploadSuccess) {
          return; // 上传失败则终止提交
        }
      }

       if (!this.form.cover || this.form.cover.length == 0) {
        alert("请上传封面图片");
        return;
      }
      if (!this.form.fileId || this.form.fileId.length == 0) {
        alert("请上传工具附件");
        return;
      }

      // 4. 提交表单数据到服务器
      try {
        const submitData = {
          title: this.form.title,
          categoryid: this.form.categoryid,
          description: this.form.description,
          link: this.form.link,
          cover: this.form.cover, // 提交服务器返回的图片URL
          fileId: this.form.fileId, // 新增：附件ID
          subid: this.form.subid
        };
        var data = await this.$aesEncrypt(submitData);

        // 调用发布工具的接口（请替换为你的实际接口）
        this.$axios({
          url: "aitool",
          method: "PUT",
          data: {
            data: data,
          },
        }).then((res) => {
          if (res.code === 200) {
            alert("工具提交成功！审核通过后将展示在平台上。");
            this.$router.push("/");
          } else {
            alert("提交失败：" + (res.msg || "服务器错误"));
          }
        });
      } catch (error) {
        console.error("提交表单失败:", error);
        alert("提交失败，请检查网络或稍后重试");
      }
    },
  },
};

// 日期格式化扩展
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
</script>
